import { render, staticRenderFns } from "./PhotoSubjectGrid.vue?vue&type=template&id=4d98d98a"
import script from "./PhotoSubjectGrid.vue?vue&type=script&lang=js"
export * from "./PhotoSubjectGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports